import { getGridMeta } from '@/service/meta-service';

export default {
    state() {
        return {
            regGrid: [],
        };
    },
    mutations: {
        setTreeListMetaData(state, data) {
            state.regGrid = [...data];
        },
    },
    actions: {
        async loadTreeListMetaData({ commit }, payload) {
            const response = await getGridMeta(`meta./${payload.api}/meta/get`, payload.name);
            if (response.result) {
                commit('setTreeListMetaData', response.meta_data);
            }
        },
        cleanTreeListMetaData({ commit }) {
            commit('setTreeListMetaData', []);
        },
    },
};
